import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    ChevronDoubleRightIcon,
    BriefcaseIcon,
    ArrowUturnDownIcon,
} from '@heroicons/react/24/outline';
import image1 from '../../assets/images/slider 1.webp';
import image2 from '../../assets/images/silde.webp';
import ImageYellowBoxLeft from '../../assets/images/boxOne.webp';
import ImageYellowBoxRight from '../../assets/images/boxTwo.webp';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import useLanguageDirection from '../../hooks/useLanguageDirection';
import { useLanguageNavigate } from '../../hooks/useLanguageNavigation';
import GalbElHabebPopup from '../iFrame/GalbElHabebPopup';
import { GalbElHabeb } from '../../redux/reducer/productReducer';
import CopyLinkWithoutBackground from '../iFrame/copyLinkWithoutBackground';
import CopyLinkWithoutBackgroundV2 from '../iFrame/copyLinkWithoutBackgroundV2';

const ScrollerSection = ({ scrollToImportantServices }) => {
    const { t } = useTranslation();
    // const navigate = useNavigate();
    const navigateWithLang = useLanguageNavigate();

    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const intervalRef = useRef(null);
    const sliderRef = useRef(null);
   const direction = useLanguageDirection();

    const images = [image1, image2];
    const texts = [
        {
            heading: t('scrollerSection.favoriteStore'),
            subheading: t('scrollerSection.toYourDoorstep'),
            description: t('scrollerSection1.shopGlobally'),
        },
        {
            heading: t('enjoyableShoppingJourney'),
            subheading: t('startWithOneStepNow'),
            description: t('scrollerSection.shopGlobally'),
        },
    ];

    const ANIMATION_DURATION = 700;
    const AUTO_SLIDE_INTERVAL = 20000;

    const slideTransition = useCallback(
    (newSlideIndex) => {
        if (isAnimating) return;

        setIsAnimating(true);

        setTimeout(() => {
        setCurrentSlide(newSlideIndex); 

        setTimeout(() => {
            setIsAnimating(false);
        }, ANIMATION_DURATION / 2);
        }, ANIMATION_DURATION / 2);
    },
    [isAnimating]
    );

    
    const goToPreviousSlide = useCallback(() => {
        const newSlide = currentSlide === 0 ? images.length - 1 : currentSlide - 1;
        slideTransition(newSlide);
    }, [currentSlide, images.length, slideTransition]);

    const goToNextSlide = useCallback(() => {
        const newSlide = currentSlide === images.length - 1 ? 0 : currentSlide + 1;
        slideTransition(newSlide);
    }, [currentSlide, images.length, slideTransition]);

    const goToSlide = useCallback((index) => {
        if (index !== currentSlide) {
            slideTransition(index);
        }
    }, [currentSlide, slideTransition]);

    const handleButtonTrukey = () => {
        navigateWithLang('/category-turkey', { replace: false });
        window.location.reload();
    };

    const handleButtonEroupa = () => {
        navigateWithLang('/category-europe', { replace: false });
        window.location.reload();
    };


    // Auto Scroll - only set once and clear on unmount
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            goToNextSlide();
        }, AUTO_SLIDE_INTERVAL);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [goToNextSlide]);

    // Reset interval when user manually changes slide
    const resetAutoSlide = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        intervalRef.current = setInterval(() => {
            goToNextSlide();
        }, AUTO_SLIDE_INTERVAL);
    }, [goToNextSlide]);

    return (
      <div className="bg-black mt-[3rem]">
        <div
          className="relative max-w-[1380px] mx-auto"
          ref={sliderRef}
          style={{ touchAction: "pan-y" }}
        >
          <div className="max-container">
            <div className="justify-between w-full py-5 bg-black nt-14 mt-lg-[100px] item-center md:flex">
              <button
                onClick={() => {
                  goToNextSlide();
                  resetAutoSlide();
                }}
                onTouchEnd={() => {
                  goToNextSlide();
                  resetAutoSlide();
                }}
                className="absolute py-2 text-white duration-500 transform -translate-y-1/2 bg-transparent rounded-full right-2 top-1/2 hover:text-custom-yellow disabled:opacity-50"
                disabled={isAnimating}
                style={{ zIndex: 10 }}
              >
                <ChevronDoubleRightIcon className="w-8 h-8 lg:w-10 lg:h-10" />
              </button>

              <div className="relative w-full md:w-1/2">
                <img
                  src={images[currentSlide]}
                  alt="slider"
                  className={`w-full h-auto transition-opacity duration-500 lg:max-h-[604px] ${
                    isAnimating ? "opacity-0" : "opacity-100"
                  }`}
                />
              </div>

              <div
                className={`lg:mt-[-75px] md:mt-0 w-full max-w-xl mx-auto  flex flex-col items-end justify-center mx-5 md:mx-0 transition-opacity duration-500 ${
                  isAnimating ? "opacity-0" : "opacity-100"
                }`}
              >
                <div className="inline-block px-8 py-2 bg-custom-yellow md:px-8">
                  <h2 className="items-end text-xl font-bold text-black lg:text-3xl">
                    {texts[currentSlide].heading}
                  </h2>
                </div>
                <div className="flex items-center">
                  <div className="bg-white inline-block px-6 md:px-8 py-2 relative top-[-18px] md:top-[-18px] lg:top-[-14px]">
                    <h2
                      className="items-end text-lg font-bold text-black lg:text-3xl"
                      dir={direction}
                    >
                      {texts[currentSlide].subheading}
                    </h2>
                  </div>
                  <img
                    src={
                      direction === "rtl"
                        ? ImageYellowBoxLeft
                        : ImageYellowBoxRight
                    }
                    alt="box"
                    className={`h-20 relative top-[-20px] ${
                      direction === "rtl" ? "right-[16px]" : "left-[16px]"
                    }`}
                  />
                </div>

                <div
                  className={`${
                    direction === "rtl"
                      ? " md:pr-14  text-center w-full"
                      : " w-full  md:pl-14 lg:min-h-max"
                  }`}
                >
                  <h2
                    className="mb-5 text-base text-center text-white md:text-start md:mb-10"
                    dir={direction}
                  >
                    {texts[currentSlide].description}
                  </h2>

                  {/* <div className="flex flex-col lg:flex-row md:justify-end gap-4 md:gap-2 lg:w-full w-[75%] md:ms-auto mx-auto">
                                    {currentSlide === 1 ? (
                                        <button
                                            className="inline-flex items-center justify-center px-4 py-2 text-base text-white transition duration-500 ease-in-out transform bg-black border border-white rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
                                            onClick={scrollToImportantServices}
                                        >
                                            {t('scrollerSection.contactUs')}
                                            <ArrowUturnDownIcon className="w-4 text-white ms-2" />
                                        </button>
                                    ) : (
                                        <button
                                            onClick={handleButtonTrukey}
                                            dir={direction}
                                            className="inline-flex items-center justify-center px-4 py-2 text-base text-white transition duration-500 ease-in-out transform bg-black border border-white rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
                                        >
                                            <BriefcaseIcon className="w-4 text-white me-2" />
                                            {t('scrollerSection.Turkish')}
                                        </button>
                                    )}

                                    {currentSlide === 0 && (
                                        <button
                                            onClick={handleButtonEroupa}
                                            dir={direction}
                                            className="z-0 inline-flex items-center justify-center px-4 py-2 text-base text-black transition duration-500 ease-in-out transform bg-custom-yellow rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
                                        >
                                            <BriefcaseIcon className="w-4 text-black me-2" />
                                            {t('scrollerSection.European')}
                                        </button>
                                    )}
                                </div> */}
                </div>
                <div
                  className={`w-full ${
                    direction === "rtl" ? "mr-10 md:mr-10" : "ml-10 md:ml-10"
                  } mx-auto md:mx-0`}
                >
                  <CopyLinkWithoutBackgroundV2 isFullWidth={true} />
                </div>

                <div></div>
              </div>

              <button
                onClick={() => {
                  goToPreviousSlide();
                  resetAutoSlide();
                }}
                className="absolute py-2 text-white duration-500 transform -translate-y-1/2 bg-transparent rounded-full left-2 top-1/2 hover:text-custom-yellow disabled:opacity-50"
                disabled={isAnimating}
              >
                <ChevronDoubleRightIcon className="w-8 h-8 transform rotate-180 lg:w-10 lg:h-10" />
              </button>
            </div>

            <div className="flex justify-center gap-3 py-4 md:py-4">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    goToSlide(index);
                    resetAutoSlide();
                  }}
                  className={`w-2.5 h-2.5 rounded-full transition-colors duration-500 ${
                    currentSlide === index ? "bg-custom-yellow" : "bg-white"
                  } ${isAnimating ? "opacity-50" : "opacity-100"}`}
                  disabled={isAnimating}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
};

export default ScrollerSection;